import logo from "assets/images/integrations/rapidmail_logo.png";
import { useCallback, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { connect, ConnectedProps } from "react-redux";
import { RootReduxState } from "../../../../../utils/types";
import { AvailableIntegrationCardAddButton } from "../../components/AvailableIntegrationCardAddButton";
import { AvailableIntegrationCardExplanationWrapper } from "../../components/AvailableIntegrationCardExplanationWrapper";
import { AvailableIntegrationCardHeader } from "../../components/AvailableIntegrationCardHeader";
import { AvailableIntegrationCardWrapper } from "../../components/AvailableIntegrationCardWrapper";
import { UsernamePasswordSetup } from "../../components/UsernamePasswordSetup/UsernamePasswordSetup";
import { ConnectViewComponentProps, IntegrationType } from "../../types";
import { RapidmailIntegrationSettings } from "./types";

type RapidmailConnectViewComponentOwnProps = ConnectViewComponentProps;

const mapStateToProps = (state: RootReduxState) => {
  const selectedShop = state.getIn([
    "customerBackendDashboard",
    "userData",
    "selectedShop"
  ]) as string;

  return {
    integrationList: state
      .getIn([
        "customerBackendDashboard",
        "shops",
        selectedShop,
        "integrations",
        "data",
        IntegrationType.RAPIDMAIL
      ])
      ?.toJS() as RapidmailIntegrationSettings[] | undefined
  };
};

const connector = connect(mapStateToProps);

type RapidmailConnectViewComponentProps = RapidmailConnectViewComponentOwnProps &
  ConnectedProps<typeof connector>;

const RapidmailConnectViewComponent = (props: RapidmailConnectViewComponentProps) => {
  const { connectingType, onStartConnecting, onStopConnecting, integrationList } = props;

  const isConnected = useMemo(
    () =>
      integrationList?.some((integration) => {
        return integration.auth && integration.auth.username;
      }) || false,
    [integrationList]
  );

  return (
    <AvailableIntegrationCardWrapper>
      {connectingType === IntegrationType.RAPIDMAIL && (
        <UsernamePasswordSetup
          authKeyVisible={false}
          integrationType={IntegrationType.RAPIDMAIL}
          onFinish={onStopConnecting}
        />
      )}
      <AvailableIntegrationCardHeader image={logo} text="rapidmail" />
      <AvailableIntegrationCardExplanationWrapper>
        <FormattedMessage
          id="containers.Integrations.ListOfApps.Shared.Short.Explanation"
          defaultMessage="Connect your {tool} account with uptain. Then new newsletter subscribers can be added to your account."
          values={{ tool: "rapidmail" }}
        />
      </AvailableIntegrationCardExplanationWrapper>
      <AvailableIntegrationCardAddButton
        isConnected={isConnected}
        loading={connectingType !== undefined}
        onConnect={useCallback(
          () => onStartConnecting(IntegrationType.RAPIDMAIL),
          [onStartConnecting]
        )}
      />
    </AvailableIntegrationCardWrapper>
  );
};

export const RapidmailConnectView = connector(RapidmailConnectViewComponent);
